import request from "./request";

// 登录
export function login(data) {
  return request({
    url: `jianxie/train-user/front/login`,
    method: "post",
    data,
  });
}

// 注册
export function registry(data) {
  return request({
    url: `jianxie/train-user/front/registerUser`,
    method: "post",
    data,
  });
}

// 完善个人信息
export function completeUserInfo(data) {
  return request({
    url: `jianxie/train-user/front/completeUserInformation`,
    method: "post",
    data,
  });
}

// 修改密码
export function updatePwd(data) {
  return request({
    url: `jianxie/train-user/front/updatePassword`,
    method: "post",
    data,
  });
}
// 新闻查询
export function getNewsList(params) {
  return request({
    url: `jianxie/sys-news/front/pageFrontNewList`,
    method: "get",
    params,
  });
}
// 新闻详情
export function getNewDetail(params) {
  return request({
    url: `jianxie/sys-news/front/getFrontNewById`,
    method: "get",
    params,
  });
}
// 培训字典
export function getTrainDic(params) {
  return request({
    url: `jianxie/train-type/system/getTrainTypeList`,
    method: "get",
    params,
  });
}
// 培训列表
export function getTrainList(params) {
  return request({
    url: `jianxie/sys-news/front/pageFrontNewList`,
    method: "get",
    params: { ...params, typeName: "在线培训" },
  });
}
// 查询我的证书申请列表
export function getMyApplyList(params) {
  return request({
    url: `jianxie/certificate-apply-form/front/pageOwerApprovalFormList`,
    method: "get",
    params,
  });
}
// 报名考试
export function applyCertificate(data) {
  return request({
    url: `jianxie/certificate-apply-form/front/submit`,
    method: "post",
    data,
  });
}
// 查询我的可考试卷
export function getMyPaper(params) {
  return request({
    url: `jianxie/examination-paper/front/getAllMyExaminationPaper`,
    method: "get",
    params,
  });
}
// 根据试卷id查询试卷详情
export function getPaperById(params) {
  return request({
    url: `jianxie/examination-paper/front/getExaminationPaperDetailById`,
    method: "get",
    params,
  });
}
// 根据试卷id查询试卷考题
export function getPaperQuestionById(params) {
  return request({
    url: `jianxie/examination-paper-question/front/getExaminationPaperVoById`,
    method: "get",
    params,
  });
}
// 获取当前用于对于此套试卷的基本信息-设置考试开始时间
export function setStartTime(data) {
  return request({
    url: `jianxie/examination-result/front/startExaminationresult`,
    method: "post",
    data,
  });
}
// 提交试卷
export function submitTestPaper(data) {
  return request({
    url: `jianxie/examination-question-result/front/submitExaminationQuestionResult`,
    method: "post",
    data,
  });
}
// 获取答题结果
export function getTestResult(params) {
  return request({
    url: `jianxie/examination-question-result/front/getQuestionResultDetailByResultId`,
    method: "get",
    params,
  });
}
// 查询考试记录
export function getTestRecord(params) {
  return request({
    url: `jianxie/examination-result/front/pageOwnerExaminationResultList`,
    method: "get",
    params,
  });
}
// 查询横幅
export function getBannerList(params) {
  return request({
    url: `jianxie/sys-banner/front/listBanner`,
    method: "get",
    params,
  });
}
// 友情链接
export function getFriendLink(params) {
  return request({
    url: `jianxie/sys-friend-link/front/listSysFriendLink`,
    method: "get",
    params,
  });
}
// 证书类型
export function getCertificateTypes(params) {
  return request({
    url: `jianxie/certificate-type/front/getCertificateTypeList`,
    method: "get",
    params,
  });
}
// 工种类型
export function getAllWorkType(params) {
  return request({
    url: `jianxie/work-type-config/system/getWorkTypeConfigList`,
    method: "get",
    params,
  });
}
// 证书查询
export function queryCertification(params) {
  return request({
    url: `jianxie/certificate-apply-form/front/getApplyByIdNo`,
    method: "get",
    params,
  });
}
// 为报名信息添加培训时间
export function updateApplyTrainTime(params) {
  return request({
    url: `jianxie/certificate-apply-form/front/addTrainTime`,
    method: "post",
    params,
  });
}
// 获取个人信息
export function getUserInfo() {
  return request({
    url: `jianxie/train-user/front/getTrainUserByToken`,
    method: "get",
  });
}
// 获取我的报名记录
export function getMyApplyRecord(params) {
  return request({
    url: `jianxie/certificate-apply-form/front/getOwnerCertificateApplyList`,
    method: "get",
    params,
  });
}
